import { render, staticRenderFns } from "./BeTabs.vue?vue&type=template&id=5b9cc5aa&"
import script from "./BeTabs.vue?vue&type=script&lang=js&"
export * from "./BeTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports